import { object, string } from "yup";
import { config } from "@/config";

/** Translated messages for recover-password personal info (email + SSN) */
export interface RecoverPasswordPersonalInfoMessages {
  validEmail: string;
  validSsn: string;
}

export const createRecoverPasswordPersonalInfoSchema = (
  messages: RecoverPasswordPersonalInfoMessages,
) =>
  object().shape({
    email: string()
      .nullable()
      .ensure()
      .required(messages.validEmail)
      .email(messages.validEmail),
    ssn: string()
      .nullable()
      .ensure()
      .required(messages.validSsn)
      .test(
        "must-have-9-digits",
        messages.validSsn,
        (value: string) => {
          const digitsOnly = (value ?? "").replace(/\D/g, "");
          return digitsOnly.length === 9;
        },
      ),
  });

/** Set recover password headers in config for unauthHttpRequest */
export const setRecoverPasswordHeaders = (
  captchaToken: string | undefined,
  guid: string,
) => {
  if (captchaToken) {
    config.setEnv("recoverPasswordCaptchaToken", captchaToken);
  }
  config.setEnv("recoverPasswordRequestGuid", guid);
};

/** Clear recover password headers from config */
export const clearRecoverPasswordHeaders = () => {
  config.setEnv("recoverPasswordCaptchaToken", "");
  config.setEnv("recoverPasswordRequestGuid", "");
};
